import { noop } from "lodash";
import moment from "moment-timezone";
import FormElement from "rc-field-form";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ButtonGroup } from "reactstrap";
import Button from "../../../../../../components/Button";
import Base from "./Base";
import Rules from "./Rules";

const BASE_STEP_ERROR_FIELDS = ["code", "description", "effectiveDate", "status"];

function Form({ mode, values: _values, error, loading, submit, close }) {
	const { t } = useTranslation();
	const [step, setStep] = useState("base");

	const [baseForm] = FormElement.useForm();
	const [rulesForm] = FormElement.useForm();

	const [values, setValues] = useState(_values);
	useEffect(() => {
		setValues(_values);
	}, [_values]);

	const onFinish = useCallback(async (form, { values: formValues, forms }) => {
		switch (form) {
			case "base": {
				setStep("rules");
				setValues((prev) => {
					return {
						...prev,
						...formValues,
					};
				});
				break;
			}
			case "rules": {
				try {
					await forms.base.validateFields();
				} catch (error) {
					if (error?.errorFields?.length > 0) {
						setStep("base");
					}
				}
				const data = {
					...values,
					...formValues,
				};
				data.effectiveDate = moment(data.effectiveDate).format("YYYY-MM-DD");
				setValues(data);
				await submit(
					data,
					noop,
					(error) => {
						const hasErrorOnFirstStep = !!Object.keys(error).find((key) => BASE_STEP_ERROR_FIELDS.includes(key));
						if (hasErrorOnFirstStep) {
							setStep("base");
						}
					},
				);
				break;
			}
		}
	}, [values, submit]);

	return (
		<FormElement.FormProvider onFormFinish={onFinish}>
			<div className="d-flex flex-column gap-y-8 overflow-hidden">
				<ButtonGroup className="w-100">
					{["base", "rules"].map((form) => {
						return (
							<Button
								key={form}
								color={step === form ? "primary" : "secondary"}
								onClick={() => {
									setValues((prev) => {
										return {
											...prev,
											...baseForm.getFieldsValue(),
											...rulesForm.getFieldsValue(),
										}
									});
									setStep(form);
								}}
							>
								{t(form)}
							</Button>
						);
					})}
				</ButtonGroup>

				<Base
					form={baseForm}
					mode={mode}
					error={error}
					values={values}
					close={close}
					hidden={step !== "base"}
				/>

				<Rules
					form={rulesForm}
					mode={mode}
					loading={loading}
					error={error}
					values={values}
					close={close}
					goBack={() => setStep("base")}
					hidden={step !== "rules"}
				/>
			</div>
		</FormElement.FormProvider>
	);
}

export default Form;
